module.exports = __webpack_public_path__ + "img/Dr. Nilesh Jayantilal Vasa.dc68b03b.jpg";